export default "__VITE_ASSET__3fb3c203__"